export var birthdayCustomField = {
  __typename: 'CustomFieldPickList',
  categoryID: '1a4cf113-ee90-4d19-aac3-25295a3f6a6b',
  name: 'Birthday month',
  value: 'August',
  valueOptions: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
export var superpowerCustomField = {
  __typename: 'CustomFieldText',
  categoryID: '2b4cf113-ee90-4d19-aac3-25295a3f6a6b',
  name: 'Superpower',
  value: 'Teleportation & claws'
};
export var anniversaryCustomField = {
  __typename: 'CustomFieldDate',
  categoryID: '3c4cf113-ee90-4d19-aac3-25295a3f6a6b',
  name: 'Anniversary',
  value: '2021-08-23'
};